/*
 * @Description: 
 * @Autor: wk
 * @Date: 2019-06-19 16:54:19
 * @LastEditors: wk
 * @LastEditTime: 2019-11-25 14:08:30
*/

/**
 * import中的webpackChunkName，为按需加载生成的JS名称，请使用 [project-name]-[module-name]，示例如下
 */
export default [
  {
    path: '/sendSms/announcementConfig',
    name: '/sendSms/announcementConfig',
    meta: {
      title: '聊天窗公告'
    },
    component: () => import(/* webpackChunkName: "example-sendSms" */ '../views/sendSms/smsConfig/announcementConfig.vue')
  },
  {
    path: '/sendSms/smsConfig',
    name: '/sendSms/smsConfig',
    meta: {
      title: '模板配置'
    },
    component: () => import(/* webpackChunkName: "example-sendSms" */ '../views/sendSms/smsConfig/smsConfig.vue')
  },
  {
    path: '/sendSms/smsLog',
    name: '/sendSms/smsLog',
    meta: {
      title: '发送日志'
    },
    component: () => import(/* webpackChunkName: "example-sendSms" */ '../views/sendSms/smsLog/smsLog.vue')
  },
  {
    path: '/sendSms/myMessage',
    name: '/sendSms/myMessage',
    meta: {
      title: '我的消息'
    },
    component: () => import(/* webpackChunkName: "example-sendSms" */ '../views/sendSms/myMessage/MyMessage.vue')
  }
]
